module.exports = __webpack_public_path__ + "img/icon_submenu14.c95e45b2.svg";